<template>
  <el-dialog
    class="notice-dialog"
    v-model="dialogTableVisible"
    center
    :show-close="false"
    width="55%"
  >
    <template #header="{ close, titleId, titleClass }">
      <div class="my-header">
        <h4 :id="titleId" :class="titleClass">请选择合同类型</h4>
        <el-icon class="el-icon--left" @click="close">
          <CircleClose />
        </el-icon>
      </div>
    </template>
    <!-- 进度轴 -->
    <el-steps :active="1" align-center>
      <el-step title="填写信息" />
      <el-step title="合同审核" />
      <el-step title="合同赋码" />
      <el-step title="完成" />
    </el-steps>
    <!-- 筛选 -->
    <div class="screen">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="合同类型">
          <el-select
            v-model="formInline.type"
            placeholder="请选择合同类型"
            clearable
          >
            <el-option label="转让" :value="1" />
            <el-option label="出租" :value="2" />
            <el-option label="抵押" :value="3" />
          </el-select>
        </el-form-item>
        <el-form-item label="交易类型">
          <el-select
            v-model="formInline.trade_type"
            placeholder="请选择交易类型"
          >
            <el-option
              v-for="(item, i) in tradeTypeList"
              :key="i"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <!-- 筛选 -->
    <div class="screen select-info">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="选择关联信息">
          <el-checkbox-group
            v-model="checkList"
            @change="checkboxChange"
            :min="1"
          >
            <el-checkbox label="是" />
            <el-checkbox label="否" />
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格信息 -->
    <div class="table" v-if="checkList && checkList[0] == '是'">
      <div class="table-head">
        <div class="table-head-item">土地基本信息</div>
        <div class="table-head-item">面积/㎡</div>
        <div class="table-head-item">金额/万元</div>
        <div class="table-head-item head-time">时间</div>
        <div class="table-head-item head-status">状态</div>
      </div>
      <div class="table-list">
        <div
          class="table-item"
          v-for="(item, i) in proList"
          :key="i"
          :class="item.isSelect ? 'active' : ''"
          @click="onClick(item)"
        >
          <div class="basic-info">
            <div class="title">{{ item.title }}</div>
            <div class="address-use">
              <span class="lable">
                <view class="iconfont icon-address"></view>
                地址：
              </span>
              {{ item.address }}
            </div>
            <div class="address-use">
              <span class="lable">
                <view class="iconfont icon-land-use"></view> 土地用途：
              </span>
              {{ item.use_type_name }}
            </div>
          </div>
          <div class="prop">{{ item.area }}</div>
          <div class="prop price">{{ item.starting_price }}</div>
          <div class="prop time">{{ timeProcessing(item.created_at, 1) }}</div>
          <div class="prop status" :class="item.isGuanLian ? '' : 'associated'">
            {{ item.isGuanLian ? "待关联" : "已关联" }}
          </div>
        </div>
      </div>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogTableVisible = false">取消</el-button>
        <el-button type="primary" @click="verify"> 确认 </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, defineProps } from "vue";
import { CircleClose } from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";
import { useStore } from "vuex";
import { timeProcessing } from "@/utils/time";
import { useRouter, useRoute } from "vue-router";

const router = useRouter();

const props = defineProps({});
const dialogTableVisible = ref(false);

const emit = defineEmits(['confirm'])

const proList = ref([]);

// type 不传为0是从首页进来的，1为从个人中心页面进来的
const type = ref(0);

const open = (list, num) => {
  type.value = num;
  let arr = [];
  console.log(store.state.contract.profile.list);
  store.state.contract.profile.list.forEach((v) => {
    if (v.guanLianList && v.guanLianList.length > 0) {
      v.guanLianList.forEach((item) => {
        arr.push(item.id);
      });
    }
  });
  console.log(arr);
  proList.value = list.map((v) => {
    return {
      ...v,
      isSelect: false,
      isGuanLian: arr ? !arr.includes(v.id) : true,
    };
  });
  dialogTableVisible.value = true;
};

// 关联信息
const checkList = ref(["是"]);
const checkboxChange = (data) => {
  console.log(data, "data");
  let arr = data.length < 2 ? data : data.splice(1, 1);
  checkList.value = arr;
  formInline.value.isGuanlian = arr[0] == "是" ? true : false;
};

const formInline = ref({});

const tradeTypeList = ref([
  {
    label: "协议交易",
    value: 1,
  },
  {
    label: "挂牌交易",
    value: 2,
  },
  {
    label: "拍卖交易",
    value: 3,
  },
  // {
  //   label: "网上推介",
  //   value: 4,
  // },
]);
const store = useStore();
const verify = () => {
  if (!formInline.value.type) {
    ElMessage.error(`请选择合同类型!`);
    return;
  }
  if (!formInline.value.trade_type) {
    ElMessage.error(`请选择交易类型!`);
    return;
  }
  if (checkList.value[0] == "是") {
    let guanLianList = proList.value.filter(
      (v) => v.isSelect && v.isSelect == true
    );
    if (!guanLianList || guanLianList.length == 0) {
      ElMessage.error(`请选择要关联的商品!`);
      return;
    }
    formInline.value.guanLianList = guanLianList;
  }
  formInline.value.isGuanlian = checkList.value[0] == "是" ? true : false;
  console.log(store.state.contract.profile.list);
  if (type.value == 0) {
    store.commit("contract/setContract", formInline.value);
    ElMessage.success(`添加合同成功!`);
    dialogTableVisible.value = false;
  } else {
    dialogTableVisible.value = false;
    store.commit("contract/setContractForm", formInline.value);
    router.push(`/member/contract/edit`);
  }
  formInline.value = {};
  checkList.value = ["是"];
};

// 选择
const onClick = (data) => {
  if (!data.isGuanLian) return;
  proList.value.forEach((v) => {
    if (data.id == v.id) {
      v.isSelect = !v.isSelect;
      formInline.value.title = v.isSelect ? v.title : "";
    } else {
      v.isSelect = false;
    }
  });
};

defineExpose({
  open,
});
</script>

<style scoped lang="less">
.my-header {
  // height: 48px;
  box-sizing: border-box;
  border-width: 0px 0px 1px 0px;
  border-style: solid;
  border-color: #d9d9d9;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1.25rem;

  .el-icon--left {
    font-size: 1.3rem;
    color: #999999;
    cursor: pointer;
  }
}

/deep/.el-step__head.is-process {
  color: #999999;
  border-color: #999999;
}

/deep/.el-step__title.is-process {
  color: #999999;
}

.screen {
  padding-top: 1rem;
  border-bottom: 1px dashed #d8d8d8;

  .el-form {
    display: flex;
    justify-content: center;
  }

  /deep/.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    background-color: #409eff;
    border-color: #409eff;
    cursor: pointer;
  }

  /deep/.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
    border-color: #fff;
    cursor: pointer;
  }

  /deep/.el-checkbox__input.is-disabled + span.el-checkbox__label {
    cursor: pointer;
  }

  /deep/.el-checkbox.is-disabled {
    cursor: pointer;
  }
}

.select-info {
  border-bottom: none;
}

.table {
  .table-head {
    /* 表头 */
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.25rem;
    background: #eaf3fb;

    .table-head-item {
      // padding: 0 3rem;
      font-size: 1rem;
      color: #333333;
      width: 9.375rem;
      text-align: center;
    }

    .head-time {
      width: 11.25rem;
    }

    .head-status {
      width: 7.5rem;
    }

    .table-head-item:first-child {
      width: 25.5rem;
    }
  }

  .table-list {
    padding: 1.25rem;
    padding-top: 0;
    height: 20rem;
    overflow-y: scroll;

    .table-item {
      padding: 1.25rem;
      padding-right: 0;
      margin-top: 1.25rem;
      /* 自动布局 */
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      border: 1px solid #d8d8d8;
      cursor: pointer;

      .basic-info {
        // padding-right: 1.25rem;
        width: 24.2rem;

        .title {
          font-size: 1.571rem;
          color: #333333;
        }

        .address-use {
          margin-top: 1.25rem;
          font-size: 0.75rem;
          color: #333333;

          .lable {
            color: #999999;

            .icon-land-use {
              font-size: 0.75rem;
            }
          }
        }

        .address-use:last-child {
          margin-top: 0.625rem;
        }
      }

      .prop {
        font-size: 1rem;
        color: #333333;
        width: 9.375rem;
        text-align: center;
      }

      .price {
        font-size: 1.571rem;
        color: #f93434;
      }

      .time {
        width: 11.25rem;
      }

      .status {
        width: 7.5rem;
        color: #349bf9;
      }

      .associated {
        color: #999999;
      }
    }
    .active {
      border: 1px solid #349bf9;
    }
  }
}
.dialog-footer {
  button {
    width: 10rem;
  }
}
</style>
<style lang="less">
// 这样写是因为dialog弹窗在vue3里面想更改头部样式不生效（el-dialog__header 穿透也没有用 ）所以只有在弹窗上加一个自定义类名 然后在这个样式下面写自己想要的样式
.notice-dialog {
  .el-dialog__header {
    padding: 0;
    margin-right: 0;
  }

  .el-dialog__body {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>
